import { NavLink, Outlet } from 'react-router-dom';
import { useGameEngine } from '../../hooks/useGameEngine.js';
import { TopBar } from '../shared/TopBar.js';
import { HiddenAdminLink } from '../shared/HiddenAdminLink.js';

export function HistoryScreen() {
  const engine = useGameEngine();
  const operationName = engine.state?.settings.operationName ?? 'מבצע בר-מצווש';

  return (
    <div className="app-page">
      <TopBar online={engine.online} operationName={operationName} />
      <div className="history-layout">
        <nav className="history-tabs mono" aria-label="ניווט היסטוריה">
          <NavLink to="/history" end className={({ isActive }) => (isActive ? 'history-tab is-active' : 'history-tab')}>
            רשימת משימות
          </NavLink>
          <NavLink to="/history/map" className={({ isActive }) => (isActive ? 'history-tab is-active' : 'history-tab')}>
            מפת פתיחות
          </NavLink>
        </nav>
        <div className="term-panel history-panel">
          <Outlet context={engine} />
        </div>
      </div>
      <HiddenAdminLink />
    </div>
  );
}
